const listColumn = {
  TICKER: 'ticker',
  PERCENT_PRICE_CHANGE: 'percentPriceChange',
  VOLUME: 'volume',
  PRICE: 'price',
  RTD11: 'financial.rtd11',
  RTD21: 'financial.rtd21',
  PB: 'financial.rtd25',
  BETA: 'financial.rtd19',
  RANKING: 'rank',
  TOTAL_RANK: 'totalRank',
  HIGH_PRICE: 'ceilingPrice',
  LOW_PRICE: 'floorPrice',
  REF_PRICE: 'referencePrice',
  CHANGE_PRICE: 'priceChange',
};

const listHideColumn = [
  'ceilingPrice',
  'floorPrice',
  'referencePrice',
  'priceChange',
  'totalRank',
];

export default {
  listColumn,
  listHideColumn,
};
